import dayjs from 'dayjs';
import { getLiveOvertimeBubble } from '../bubbles';
import getLiveOfferStatus from '../live';

const getOvertimeOfferStatus = ({ overrideDateNow, currentUserTopOfferer, vehicle }) => {
	const { my_offer_amount, bid_sale_auction_ends_at } = vehicle;
	const currentUserHasOffered = !!my_offer_amount;
	const isEnded = dayjs(bid_sale_auction_ends_at).isBefore(dayjs(overrideDateNow));

	if (isEnded) {
		return {
			...getLiveOvertimeBubble(currentUserTopOfferer, currentUserHasOffered, vehicle),
			extended: true,
		};
	} else {
		return getLiveOfferStatus({ currentUserTopOfferer, vehicle });
	}
};

export default getOvertimeOfferStatus;
